<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/setting/groups">{{ $t('user_group_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                                <label class="label-control">{{$t('user_group_name')}}</label>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model"/>
                            </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-lg-1">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Sort.$error }">
                                <label class="label-control">{{$t('sort')}}</label>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Sort.$model"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="label-control">{{$t('module_allowed')}}</label>
                                <div>
                                    <ul class="module">
                                        <li v-for="(ret,index) in modules" :key="index">
                                            <label><input type="checkbox" v-model="ret.Checked"> {{$t(ret.LangKey).toUpperCase()}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import User from '../../shared/models/User'
    import { required } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model: {
                    Name: '',
                    Sort: 0
                },
                modules: [],
                title: this.$t('user_group_create')
            }
        },
        async created(){
            let res = await User.listModules({});
            this.modules = res.Modules;

            let id = this.$route.params.id;

            if(id !== undefined){
                this.findById(id);
                this.title = this.$t('user_group_edit')
            }
        },
        validations:{
            model: {
                Name: { required },
                Sort: { required }
            }
        },
        methods: {
            findById: function(id){
                let loading = this.$loading.show();
                User.findGroupById({ Id: id }).then(res => {
                    this.model = res.Group;
                    this.applyCheck(res.Modules);
                }).finally(() => { loading.hide(); });
            },
            save: function(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    let moduleIds = [];
                    for(let i = 0; i < this.modules.length; i++){
                        let item = this.modules[i];
                        if(item.Checked === true) moduleIds.push(item.Id);
                    }
                    this.model.ClientId = this.$store.state.auth.ClientId;
                    let req = {
                        Group: this.model,
                        ModuleIds: moduleIds
                    };
                    this.$api().post('user/group-save', req).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.push('/setting/groups');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            applyCheck(lines){
                lines.forEach(element => {
                    let filter = this.modules.find(el => el.Id == element.ModuleId);
                    if(filter != undefined) filter.Checked = true;
                });
            }
        }
    }
</script>
<style scoped>
    .module{
        padding: 0;
        margin: 0;
    }
    .module li{
        list-style: none;
    }
</style>